import { connectRouter } from "connected-react-router";
import { History } from "history";
import { Reducer, combineReducers } from "redux";
import { FormStateMap, reducer as formReducer } from "redux-form";

import { PageAlertState } from "../../types/appTypes/general";
import { MiniMessageBox, PageAlert } from "../components";
import groupGet, { GroupGetState } from "./appReducers/groups/get";
import userPermissionsGet, { UserPermissionsGetState } from "./appReducers/userPermissions/get";

interface MiniMessageBoxState {
  show: boolean;
  type: string;
  message: string;
}

export interface RootState {
  form: FormStateMap;
  pageAlert: PageAlertState;
  miniMessageBox: MiniMessageBoxState;
  groupGet: GroupGetState;
  userPermissionsGet: UserPermissionsGetState;
}

export default (history: History): Reducer =>
  combineReducers({
    form: formReducer,
    router: connectRouter(history),
    miniMessageBox: MiniMessageBox.miniMessageBoxReducer,
    pageAlert: PageAlert.pageAlertReducer,
    groupGet,
    userPermissionsGet,
  });
